import { getProfileIdModelUtil } from '../../../../../models/utils/get-profile-id'
import isOwnerModelUtil from '../../../../../models/utils/is-owner'
import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import getByPlanIdDomainListPathFromPlanIdWorkoutUtil
  from '../../../../../modules/workout/model/utils/get-by-plan-id-domain-list-path'
import getWeekStrWorkoutUtil from '../../../../../modules/workout/model/utils/get-by-week-domain-list-path'
import getLoggedAtWorkoutUtil from '../../../../../modules/workout/model/utils/get-logged-at'
import getPlanIdWorkoutUtil from '../../../../../modules/workout/model/utils/get-plan-id'
import getPlannedAtWorkoutUtil from '../../../../../modules/workout/model/utils/get-planned-at'
import isInPlanWorkoutUtil from '../../../../../modules/workout/model/utils/is-in-plan'
import isRecommendedWorkoutUtil from '../../../../../modules/workout/model/utils/is-recommended'

import { getCurrentProfileSelect } from '../../../../profile/redux/selectors/get-current'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import { getDomainListPathWorkoutsSelect } from '../../../../workouts-ui/selectors/get-domain-list-path'
import WORKOUTS_PATH from '../../../redux/constants/path'
import canEditByIdWorkoutSelector from '../../../redux/selectors/can-edit-by-id'
import isInStartedPlanWorkoutSelector from '../../../redux/selectors/is-in-started-plan'
import getByProfileIdDataPeriodDomainListPathsReduxUtil
  from '../../../../redux/utils/get-by-profile-id-data-period-domain-list-paths'
import getByProfileIdDomainListPathReduxUtil from '../../../../redux/utils/get-by-profile-id-domain-list-path'

function getDomainListPathsWorkoutUtil (instance, state) {
  const profileId = getValueReduxUtil(instance, WORKOUT_KEY.PROFILE_ID)

  let domainListPaths = []

  const isInPlan = isInPlanWorkoutUtil(instance)
  if (isInPlan) {
    domainListPaths.push(getByPlanIdDomainListPathFromPlanIdWorkoutUtil({
      planId: getPlanIdWorkoutUtil(instance),
      week: getWeekStrWorkoutUtil(instance)
    }))
  }

  const loggedAt = getLoggedAtWorkoutUtil(instance)
  const plannedAt = getPlannedAtWorkoutUtil(instance)
  if (loggedAt) {
    domainListPaths.unshift(getByProfileIdDomainListPathReduxUtil(WORKOUTS_PATH.LOGGED,
      profileId
    ))
    domainListPaths = [
      ...domainListPaths,
      ...getByProfileIdDataPeriodDomainListPathsReduxUtil({
        instance,
        state,
        date: new Date(loggedAt)
      })
    ]
  } else if ((
    plannedAt &&
    (
      !isInPlan ||
      (
        isInPlan &&
        (
          isInStartedPlanWorkoutSelector(instance)(state) || // TODO omit when the
          // started plan gets loaded
          // for the
          // client
          (
            !isOwnerModelUtil(instance, getCurrentProfileSelect(state))
          )
        )
      )
    )
  )) {
    domainListPaths.unshift(getByProfileIdDomainListPathReduxUtil(WORKOUTS_PATH.PLANNED,
      profileId
    ))
    domainListPaths.unshift(getByProfileIdDomainListPathReduxUtil(WORKOUTS_PATH.NON_LOGGED_AND_PLANNED,
      profileId
    ))
    domainListPaths = [
      ...domainListPaths,
      ...getByProfileIdDataPeriodDomainListPathsReduxUtil({
        instance,
        state,
        date: new Date(plannedAt)
      })
    ]
  }

  if (domainListPaths.length) {
    return domainListPaths
  }

  domainListPaths = []
  const canEdit = (
    canEditByIdWorkoutSelector(getIdReduxUtil(instance))(state)
  )

  if (isRecommendedWorkoutUtil(instance) && canEdit) {
    domainListPaths = [WORKOUTS_PATH.RECOMMENDED]
  }

  return [
    ...domainListPaths,
    getDomainListPathWorkoutsSelect(state,
      WORKOUTS_PATH.NON_LOGGED,
      getProfileIdModelUtil(instance)
    ),
    getDomainListPathWorkoutsSelect(state,
      WORKOUTS_PATH.NON_LOGGED_AND_PLANNED,
      getProfileIdModelUtil(instance)
    )
  ]
}

function getDomainListPathWorkoutUtil (instance, state) {
  return getDomainListPathsWorkoutUtil(instance, state)[0]
}

export { getDomainListPathsWorkoutUtil, getDomainListPathWorkoutUtil }
